import { studentRequests } from "api/studentApi";
import { tenants } from "utils/tenants";
import AffectedYearsSection from "./AffectedYearsSection";
import DisciplinesGrid from "./DisciplinesGrid";
import FacultativeDisciplinesGrid from "./FacultativeDisciplinesGrid";
import CyclicDisciplinesGrid from "./CyclicDisciplinesGrid";
import ElectiveGroupsGrid from "./ElectiveGroupsGrid";
import PracticesGrid from "./PracticesGrid";
import InternshipsGrid from "./InternshipsGrid";
import StateExamsGrid from "./StateExamsGrid";
import ThesisGrid from "./ThesisGrid";
import DisciplineFields from "../forms/DisciplineFields";
import FacultativeDisciplineFields from "../forms/FacultativeDisciplineFields";
import CyclicDisciplineFields from "../forms/CyclicDisciplineFields";
import ElectiveGroupFields from "../forms/ElectiveGroupFields";
import PracticeFields from "../forms/PracticeFields";
import InternshipFields from "../forms/InternshipFields";
import StateExamFields from "../forms/StateExamFields";
import ThesisFields from "../forms/ThesisFields";

const sumOf = (items, field) => items.reduce((total, item) => total + (Number(item?.[field]) || 0), 0);

const countAndCredits = items => [
  { label: "Записи", value: items.length },
  { label: "Кредити", value: sumOf(items, "credits") },
];

const scheduledItemsSummary = items => [
  { label: "Записи", value: items.length },
  { label: "Кредити", value: sumOf(items, "credits") },
  { label: "Календарни дни", value: sumOf(items, "durationInCalendarDays") },
];

// `key` names both the array on the curriculum record and the property the endpoint expects.
export const collections = [
  {
    key: "disciplines",
    label: "Дисциплини",
    singular: "дисциплина",
    request: studentRequests.updateCurriculumDisciplines,
    Grid: DisciplinesGrid,
    FormFields: DisciplineFields,
    summary: items => [
      { label: "Записи", value: items.length },
      {
        label: "Аудиторни часове",
        value:
          sumOf(items, "lecturesAuditoriumOccupancy") +
          sumOf(items, "seminarExercisesAuditoriumOccupancy") +
          sumOf(items, "laboratoryExercisesAuditoriumOccupancy") +
          sumOf(items, "practicalExercisesAuditoriumOccupancy"),
      },
      { label: "Извънаудиторни", value: sumOf(items, "extracurricularActivities") },
    ],
  },
  {
    key: "facultativeDisciplines",
    label: "Факултативни дисциплини",
    singular: "факултативна дисциплина",
    request: studentRequests.updateCurriculumFacultativeDisciplines,
    Grid: FacultativeDisciplinesGrid,
    FormFields: FacultativeDisciplineFields,
    summary: items => [{ label: "Записи", value: items.length }],
  },
  {
    key: "cyclicDisciplines",
    label: "Циклични дисциплини",
    singular: "цикъл",
    tenancies: [tenants.MU],
    request: studentRequests.updateCurriculumCyclicDisciplines,
    Grid: CyclicDisciplinesGrid,
    FormFields: CyclicDisciplineFields,
    summary: items => [
      { label: "Цикли", value: items.length },
      { label: "Под-цикли", value: items.reduce((total, item) => total + (item?.disciplines?.length ?? 0), 0) },
      { label: "Общо часове", value: sumOf(items, "totalHours") },
    ],
  },
  {
    key: "electiveGroups",
    label: "Избираеми дисциплини",
    singular: "избираема група",
    request: studentRequests.updateCurriculumElectiveGroups,
    Grid: ElectiveGroupsGrid,
    FormFields: ElectiveGroupFields,
    getItemLabel: item => item?.nameBg,
    summary: items => [
      { label: "Групи", value: items.length },
      { label: "Дисциплини в тях", value: items.reduce((total, item) => total + (item?.disciplines?.length ?? 0), 0) },
      { label: "Кредити", value: sumOf(items, "credits") },
    ],
  },
  {
    key: "practices",
    label: "Практики",
    singular: "практика",
    request: studentRequests.updateCurriculumPractices,
    Grid: PracticesGrid,
    FormFields: PracticeFields,
    summary: scheduledItemsSummary,
  },
  {
    key: "internships",
    label: "Стажове",
    singular: "стаж",
    request: studentRequests.updateCurriculumInternships,
    Grid: InternshipsGrid,
    FormFields: InternshipFields,
    summary: scheduledItemsSummary,
  },
  {
    key: "stateExams",
    label: "Държавни изпити",
    singular: "държавен изпит",
    request: studentRequests.updateCurriculumStateExams,
    Grid: StateExamsGrid,
    FormFields: StateExamFields,
    summary: countAndCredits,
  },
  {
    key: "thesis",
    label: "Дипломна работа",
    singular: "дипломна работа",
    request: studentRequests.updateCurriculumThesis,
    Grid: ThesisGrid,
    FormFields: ThesisFields,
    summary: countAndCredits,
  },
  {
    key: "specialitiesAffectedYears",
    label: "Засегнати години",
    singular: "засегната година",
    request: studentRequests.updateCurriculumSpecialityAffectedYears,
    Section: AffectedYearsSection,
  },
];
